module.exports = __webpack_public_path__ + "static/img/red-bag.18abea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/red-bag.png
// module id = WyGr
// module chunks = 216